import { SoulEntityType } from "../../enums";

import { SoulEntityCtx } from "./soul-entity-context.types";

export function generateSoulEntityContextPath(
  params: SoulEntityCtx["params"],
  prefix = "",
  postfix = "",
  search = "",
): string {
  if (params && "orderUuid" in params && params.orderUuid) {
    return `${prefix}/${SoulEntityType.ORDER}/${params.orderUuid}${postfix}${search}`;
  }

  if (params && "contentUuid" in params && params.contentUuid) {
    return `${prefix}/${SoulEntityType.CONTENT}/${params.contentType}/${params.contentUuid}${postfix}${search}`;
  }

  return `${prefix}${postfix}${search}`;
}
